import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import {
  getPlaceList,
  getCategories,
  getPlaceListForPrice,
} from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { MdAdd } from "react-icons/md";
import { Input } from "reactstrap";
import Pagination from "../../Components/Paginate";
import { CSVLink } from 'react-csv';
import { BiSolidFileExport } from 'react-icons/bi';
import { getBookingFormData } from "../../redux/actions/indexActions";


const BookingForms = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: {
      categoriesList,
      ticketBookingForms,
      ticketBookingFormsCount,
      PricePlaceLists,
      ticketBookingFormsList
    },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);

  console.log('ticketBookingFormsList>>>',ticketBookingFormsList);
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [subSubCategory, setSubSubCategory] = useState("");
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [subSubCategoryList, setSubSubCategoryList] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [sort, setSort] = useState('desc');
  const [paginate, setPaginate] = useState(10);
  const [placeId, setPlaceId] = useState('');
  const [loading, setLoading] = useState(true);
  const [prevData, setPrevData] = useState({
    value: "",
    idx: "",
  });
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  useEffect(() => {
    dispatch(getBookingFormData(auth?.token,paginate, placeId, page, search, sort))
  }, [auth, paginate, placeId, page, search, sort]);

  useEffect(() => {
    dispatch(getCategories(auth.token));
    dispatch(getPlaceListForPrice(auth.token));
  }, [auth]);

  useEffect(() => {
    if (category) {

      axios(`/api/admin/v1/get-subcategory-by-category/${category}`)
        .then(({ data }) => {
          console.log(data, 'data loaded ');
          setSubCategoryList(data?.subCategoriesbyCategory);
        })
        .catch((err) => console.error(err));
    } else {
      setSubCategoryList([]);
    }
  }, [category]);

  useEffect(() => {
    if (subCategory) {
      axios(`/api/admin/v1/get-subsubcategory-by-subcategory/${subCategory}`)
        .then(({ data }) => {
          console.log(data, 'ldad');
          setSubSubCategoryList(data?.subSubCategoriesbySubCategory);
        })
        .catch((err) => console.error(err));
    } else {
      setSubSubCategoryList([]);
    }
  }, [subCategory]);

  const csvHead = [['Place', 'Tourist Type', 'Ticket Type', 'Ticket Sub Type']]
  const csvData = ticketBookingForms.map((cv) => [
    cv?.place?.place_name,
    cv?.place_tourist_type?.tourist_type,
    cv?.ticket_type?.ticket_type,
    cv?.ticket_sub_type?.sub_type,
  ])
  const exportData = csvHead.concat(csvData);


  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedItems(ticketBookingForms.map((item) => item.id));
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (e, id) => {
    if (e.target.checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
    }
  };
  const isSelected = (id) => selectedItems.includes(id);

  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Booking form")) {
      axios
        .delete(`/api/admin/v1/delete-booking-form/${id}`, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          dispatch(getBookingFormData(auth?.token,paginate, placeId, page, search, sort));
        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };
  const handleDelALl = (selectedItems) => {
    if (window.confirm("Are You Sure You Want To Delete Selected Place")) {
      axios
        .post(`/api/admin/v1/multiple-place-delete`,
          { selectedItems }, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          dispatch(getBookingFormData(auth?.token,paginate, placeId, page, search, sort));
        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };
  const [checkedItems, setCheckedItems] = useState({});
  useEffect(() => {
    if (ticketBookingForms && ticketBookingForms.length > 0) {
      const initialCheckedItems = ticketBookingForms.reduce((acc, item) => {
        acc[item.id] = item.booking_status === 1;
        return acc;
      }, {});
      setCheckedItems(initialCheckedItems);
    }
  }, [ticketBookingForms]);

  const handleCheckboxChange = async (id, checked) => {
    setCheckedItems((prev) => ({
      ...prev,
      [id]: checked,
    }));

    try {
      const response = await axios.put(
        '/api/admin/v1/update-book-status',
        {
          id,
          status: checked ? 1 : 0,
        },
        {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );
      console.log('API response:', response.data);
    } catch (error) {
      console.error('Error updating book status:', error);
    }
  };
  const [lovedItems, setLovedItems] = useState({});
  useEffect(() => {
    if (ticketBookingForms && ticketBookingForms.length > 0) {
      const initialLovedItems = ticketBookingForms.reduce((acc, item) => {
        acc[item.id] = item.loved_place === 1;
        return acc;
      }, {});
      setLovedItems(initialLovedItems);
    }
  }, [ticketBookingForms]);


  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between" >
            <h5 className="mb-0 text-white fs-4">Booking Forms</h5>
            {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "PLACES" && item?.permission?.permission === "create") && (
              <Link to="/add-ticket-info">
                <Button className="bg-white text-black" size="sm">
                  <span className="me-2">
                    <MdAdd size={22} />
                  </span>
                  Add Ticket Info
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}>

        <div className="row">
          <div className="col-md-2 mb-2">
            <Input size={"sm"} value={search} placeholder='Search By Name' onChange={(({ target: { value } }) => setSearch(value))} />
          </div>
          <div className="col-md-2">
            <Input size={"sm"}
              type="select"
              name="place"
              value={placeId} onChange={(({ target }) => setPlaceId(target.value))}
            >
              <option value="">Select Place</option>
              {PricePlaceLists?.map?.((item) => {
                return (
                  <option value={item.id} key={item.id}>
                    {item?.place_name}
                  </option>
                );
              })}
            </Input>
          </div>
          {/* <div className="col-md-2">
            <Input size={"sm"}
              type="select"
              name="subCategory"
              value={subCategory} onChange={(({ target }) => setSubCategory(target.value))}
            >
              <option value="">Select Sub Category</option>
              {subCategoryList?.map?.((item) => {
                return (
                  <option value={item.id} key={item.id}>
                    {item?.name_english}
                  </option>
                );
              })}
            </Input>
          </div>
          <div className="col-md-3">
            <Input size={"sm"} type="select" name="subSubCategory" value={subSubCategory} onChange={(({ target }) => setSubSubCategory(target.value))}>
              <option value="">Select Sub Sub Category</option>
              {subSubCategoryList?.map?.((item) => {
                return (
                  <option value={item.id} key={item.id}>
                    {item?.name_english}
                  </option>
                );
              })}
            </Input>
          </div> */}
          <div className={`col-md-2 ${allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "PLACES" &&
              item?.permission?.permission === "export"
          ) ? "" : "offset-md-6"}`}>
            <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "PLACES" &&
            item?.permission?.permission === "export") && (
              <div className="col-md-1 mb-2">
                <CSVLink
                  filename={
                    "place-lists.csv"
                  }
                  className="text-black ms-1"
                  title="Export To CSV"
                  data={exportData}
                >
                  <BiSolidFileExport size={25} />
                </CSVLink>
              </div>
            )}

          <div className="col-md-12">
            <button
              className="btn btn-secondary btn-sm mr-1"
              disabled={!selectedItems.length}
              // onClick={handleDel}
              onClick={() => handleDelALl(selectedItems)}
            >
              <i className="fa fa-trash pr-1" />{" "}
              Delete
            </button>
            <Table hover responsive>
              <thead>
                <tr>
                  <th>
                    <Input type="checkbox" onChange={handleSelectAll} checked={selectedItems.length === ticketBookingForms.length} />
                  </th>
                  <th>SL. No.</th>
                  <th>Place</th>
                  <th>Form Type</th>
                  <th>Individual Form Name</th>
                  <th>Single Day Booking</th>
                  <th>Duration Booking</th>
                  {allowedPermissions?.some?.(
                    (item) =>
                      item?.permission?.moduleType === "BOOKINGFORM" &&
                      (item?.permission?.permission === "Edit" ||
                        item?.permission?.permission === "Delete")
                  ) && (
                      <th>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {ticketBookingForms.length === 0 ? (
                  <tr>
                    <td colSpan="12">No data found</td>
                  </tr>
                  
                ) : (<>
                  {ticketBookingForms?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>

                        <td> <Input
                          type="checkbox"
                          checked={isSelected(item.id)}
                          onChange={(e) => handleSelectItem(e, item.id)}
                        /></td>
                        <td scope="row">{index + 1 + page * paginate}</td>
                        <td> {item?.place?.place_name} </td>
                        <td> {item?.form_type} </td>
                        <td> {(item?.individual_form_name) ? item?.individual_form_name : "N/A"} </td>
                        <td> {(item?.is_single_day_booking == 1) ? "Yes" : "NO"} </td>
                        <td> {(item?.enable_duration == 1) ? "Yes" : "NO"} </td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "BOOKINGFORM" &&
                                item?.permission?.permission === "Edit"
                            ) && (
                                <Link to={`/edit-ticket-info/${item?.id}`}>
                                  <AiOutlineEdit
                                    size={22}
                                    className="text-warning me-3"
                                  />
                                </Link>
                              )}
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "BOOKINGFORM" &&
                                item?.permission?.permission === "Delete"
                            ) && (
                                <AiOutlineDelete
                                  size={22}
                                  className="text-danger"
                                  onClick={() => handleDel(item.id)}
                                />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                id="paginate"
                onChange={e =>
                  setPaginate(
                    Number(e.target.value)
                  )
                }
                value={paginate}
                className="paging custom-select custom-select-page m-0"
              >
                <option value="10">
                  10
                </option>
                <option value="20">
                  20
                </option>
                <option value="50">
                  50
                </option>
                <option value="100">
                  100
                </option>
                <option value="200">
                  200
                </option>
                <option value="500">
                  500
                </option>
              </Input>
            </div>
            <div className='col-md-10 text-black d-flex align-items-center ps-3'>
              {ticketBookingFormsCount > 0 ? (
                <>
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, ticketBookingFormsCount)} of {ticketBookingFormsCount} entries
                </>
              ) : (
                <>
                  Showing 0 to 0 of 0 entries
                </>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex justify-content-end'>
              <Pagination
                pageCount={Math.ceil(ticketBookingFormsCount / paginate)}
                previousLabel="«"
                nextLabel="»"
                onChange={(e) => setPage(e.selected)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingForms;
